






































































































import {Vue, Component, Watch} from 'vue-property-decorator';
import TuiGrid from 'tui-grid';
import PageTitle from '@/components/common/PageTitle.vue';
import MallsTab from '@/components/common/MallsTab.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import {GetMailMessagesRequest, GetMailMessage, ManageMessageStatus, GetMailMessagesViewRequest, Mall, GetMallsDataRequest} from 'supporter';
import {i18nInObjectList, i18nObjectByKey} from '@/utils/i18n';
import {getToday, addDay} from '@/utils/dateUtils';
import {PopupRequestData} from '@/types';
import {State, namespace} from 'vuex-class';
const mallModule = namespace('mall');
@Component({
  components: {
    PageTitle,
    MallsTab,
    PeriodDateCalendar,
    ItemTable
  }
})
export default class SendList extends Vue {
  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<any>;
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private mallNo: number = 0;
  @State private onGnb!: boolean;
  private mailSendView: GetMailMessage[] = [];
  private pageSize: number = 100;
  private totalCount: number = 0;
  private status: string = '';
  private isPreview: boolean = false;
  private previewContents: string = '';
  private previewTitle: string = '';
  private emailUsed: boolean = false;
  private dispatchPreviewPopupRequestData: PopupRequestData = {
    id: 'previewcontent',
    width: 800,
    maxHeight: 1000,
    title: 'MAIL_SEND_LIST_POPUP_TITLE',
    hasConfirmBtn: false,
    hasCloseBtn: true
  };
  private startYmdt: string = addDay(new Date(), -7);
  private endYmdt: string = getToday();
  private periodOption = {
    periodTypes: ['td', 'ytd', '3d', '1w', '1m'],
    period: '1w'
  };
  private messageStatusArr = [
    {
      value: '',
      label: 'MAIL_SEND_LIST_MESSAGE_STATUS_ONE'
    },
    {
      value: 'READY',
      label: 'MAIL_SEND_LIST_MESSAGE_STATUS_TWO'
    },
    {
      value: 'PROGRESS',
      label: 'MAIL_SEND_LIST_MESSAGE_STATUS_THREE'
    },
    {
      value: 'COMPLETE',
      label: 'MAIL_SEND_LIST_MESSAGE_STATUS_FOUR'
    },
    {
      value: 'FAIL',
      label: 'MAIL_SEND_LIST_MESSAGE_STATUS_FIVE'
    }
  ];
  // ====== For grid ========
  private tableOptions = {
    pageSize: 100,
    haveExcelDownBtn: false,
    pageSizes: [
      {
        value: 100,
        name: 'COMMON_PAGE_SIZE_100'
      },
      {
        value: 200,
        name: 'COMMON_PAGE_SIZE_200'
      },
      {
        value: 500,
        name: 'COMMON_PAGE_SIZE_500'
      },
      {
        value: 1000,
        name: 'COMMON_PAGE_SIZE_1000'
      }
    ]
  };
  private gridProps = {
    options: {
      pageOptions: {
        perPage: this.pageSize,
        page: 1,
        totalCount: 0
      }
    },
    minBodyHeight: 31,
    scrollY: false,
    copyOptions: {
      useFormattedValue: true
    },
    columns: [
      {
        header: 'MAIL_SEND_LIST_TABLE_HEADER_ONE',
        name: 'requestId',
        align: 'center',
        minWidth: 85,
        formatter: (data: any) => {
          return `<span class="requestDetail" onclick="window.open(
            \'/mail/popup/recipient-list?mallNo=${data.row.mallNo}&requestId=${data.row.requestId}&seq=${data.row.sequence}\',
            \'SendListPopup\',
            \'top=100, left=350, scrollbars=no, width=980, height=770, resizable=no\'
          )">${data.value}</span>`;
        }
      },
      {
        header: 'MAIL_SEND_LIST_TABLE_HEADER_TWO',
        name: 'title',
        align: 'center',
        minWidth: 85,
        formatter: (data: any) => {
          return `<span class="contentsView"><div class="ellipsis" data-id="${data.row.requestId}" data-seq="${data.row.sequence}">${data.value}</div></span> `;
        }
      },
      {
        header: 'MAIL_SEND_LIST_TABLE_HEADER_THREE',
        name: 'statusName',
        align: 'center',
        minWidth: 85
      },
      {
        header: 'MAIL_SEND_LIST_TABLE_HEADER_FOUR',
        name: 'requestDateTime',
        align: 'center',
        minWidth: 85
      }
    ]
  };
  @Watch('$route.query.mallNo', {immediate: false, deep: false})
  onmallNo() {
    this.search();
  }
  private search(page: number = 1, size?: number): void {
    let theObj: GetMailMessagesRequest = {
      params: {
        mallNo: Number(this.$route.query.mallNo),
        startDate: this.startYmdt,
        endDate: this.endYmdt,
        page: page ? page : 1,
        pageSize: size ? size : (this.$refs.itemTable as any).itemInfo.pageSize
      }
    };
    if (this.status !== '') {
      theObj.params.messageStatus = this.status as ManageMessageStatus;
    }
    this.$api.getMailMessages(theObj).then((res) => {
      res.data.data.map((item: any) => {
        Vue.set(item, 'mallNo', this.$route.query.mallNo);
      });
      this.mailSendView = res.data.data;
      this.totalCount = res.data.totalCount;
      this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
      this.gridProps.options.pageOptions.perPage = theObj.params.pageSize;
      this.gridProps.options.pageOptions.page = theObj.params.page;
    });
  }
  private reset(): void {
    let tempVue: any = this.$refs.datePicker;
    tempVue.clickPeriod('1w');
    this.status = '';
  }
  private showViewPop(e: any): void {
    let theObj: GetMailMessagesViewRequest = {
      params: {
        mallNo: Number(this.$route.query.mallNo),
        requestId: $(e.target).data('id'),
        seq: $(e.target).data('seq')
      }
    };
    this.isPreview = true;
    this.$api.getMailMessagesView(theObj).then((res) => {
      this.previewContents = res.data.content;
      this.previewTitle = res.data.title;
    });
  }
  private async configurations() {
    const configRequest: GetMallsDataRequest = {
      params: {
        mallNo: this.mallNo
      }
    };

    await this.$api
      .getNotificationsConfigurations(configRequest)
      .then((res) => {
        this.emailUsed = res.data.emailUsed;
      })
      .catch((e: any) => {
        if (e.data.code === 'MC0002') {
          this.emailUsed = false;
        }
      });
    if (!this.emailUsed) {
      window.location.assign(`/mail/usage-list?mallNo=${this.mallNo}&tabNo=5`);
    }
  }
  @Watch('$route.query.mallNo', {immediate: false, deep: false})
  async onMallChanged() {
    if (this.$route.query.mallNo) {
      this.mallNo = Number(this.$route.query.mallNo);
    } else {
      this.mallNo = this.malls[0].mallNo;
    }
    this.toFirstPage();
    // await this.configurations();

  }
  private toFirstPage() {
    // console.log(this.$route.query.mallNo)
    // window.location.reload();
    let url = `/mail/dispatch?mallNo=${this.mallNo}&tabNo=1`;
    window.location.assign(url);
  }
  private created() {
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
     let noData = this.$t('MAIL_SEND_LIST_NO_DATA') as string;
     TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
    this.dispatchPreviewPopupRequestData = i18nObjectByKey(this, this.dispatchPreviewPopupRequestData, 'title');
  }
  private async mounted() {
    await this.fetchMalls();
    if (this.$route.query.mallNo) {
      this.mallNo = Number(this.$route.query.mallNo);
    } else {
      this.mallNo = this.malls[0].mallNo;
    }
    this.search();
    $('body').on('click', '.ellipsis', $.proxy(this.showViewPop, this));
    await this.configurations();
  }
}
